import { createApp } from 'vue';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router';
import SplashPage from './components/SplashPage.vue';
import BlogPage from './components/BlogPage.vue';

const routes = [
  { path: '/', component: SplashPage },
  { path: '/blog', component: BlogPage }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

createApp(App).use(router).mount('#app');
